var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.77,
    height: 55.962,
    viewBox: "0 0 56.77 55.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 56.77,
    height: 55.962,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.435
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 8 \\u2013 2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 524",
    transform: "translate(9 6)",
    style: {
      fill: "#404040",
      stroke: "#7c7c7c",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.77,
    height: 37.962,
    rx: 18.981,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 36.77,
    height: 35.962,
    rx: 17.981,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "c9f0f895fb98ab9159f51fd0297e236d (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M25.026 118.07v5.239a.705.705 0 0 1-.7.7h-4.19v-4.192h-2.795v4.192h-4.192a.705.705 0 0 1-.7-.7v-5.239a.147.147 0 0 1 .005-.032.148.148 0 0 0 .005-.032l6.277-5.176 6.28 5.17a.154.154 0 0 1 .011.066zm2.435-.754-.677.808a.373.373 0 0 1-.23.12h-.032a.333.333 0 0 1-.23-.077l-7.554-6.3-7.554 6.3a.412.412 0 0 1-.262.077.369.369 0 0 1-.23-.12l-.677-.808a.36.36 0 0 1-.077-.257.316.316 0 0 1 .12-.235l7.849-6.539a1.355 1.355 0 0 1 1.66 0l2.664 2.227v-2.128a.338.338 0 0 1 .35-.35h2.1a.338.338 0 0 1 .35.35v4.454l2.391 1.988a.313.313 0 0 1 .12.235.354.354 0 0 1-.075.255z",
    transform: "translate(8.996 -91.691)",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.2691a734.svg";
export { ForwardRef as ReactComponent };